<template>
<operator v-model="valueId" :disabled="disabled" @change="handleChange"></operator>
</template>


<style lang="scss">

</style>
<script>
    import SelectTree from "../TreeSelect/index";

    export default {
        name: "OperatorToId",
        components: {
            SelectTree
        },
        watch:{
            value:{
                immediate:true,
                handler(value){
                    if (value) {
                        this.valueId = {value:value};
                    } else {
                        this.valueId =null ;
                    }

                }
            }
        },
        props:{
               disabled:{
                 type: Boolean,
                    default(){
                        return false;
                    }
            },
            value:{}
        },
        data() {
            return {
                valueId:null
            };
        },


        methods:{


          handleChange(value){

              this.$emit("change",value.value)
              this.$emit("input",value.value)
          }




        },

    };
</script>

<style>
  /*#app {*/
  /*  font-family: "Avenir", Helvetica, Arial, sans-serif;*/
  /*  -webkit-font-smoothing: antialiased;*/
  /*  -moz-osx-font-smoothing: grayscale;*/
  /*  text-align: center;*/
  /*  color: #2c3e50;*/
  /*  margin-top: 60px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/operation/OperatorToId.vue